import  "./LevelSelection.css";
import { Button, Card } from "antd";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";
import Placevalue from "./Placevalue";

const LevelSelection = ({ category,level,onSelectLevel }) => {
  const { width, height } = useWindowSize();
  const motivationList = ["Sharp-witted","Smart","Bright","Awesome","Amazing","Brilliant","Fantastic"];
  const timeGroups = [
  {
    title: "🕒 Time Basics",
    desc: "Learn to read and calculate time.",
    className: "math-card",
    btnClass: "level-btn",
    levels: [1, 2, 3],
  },
  {
    title: "⏰ Time Conversion",
    desc: "Practice converting different time units.",
    className: "science-card",
    btnClass: "science-btn",
    levels: [
      "Min Sec Conversion",
      "24hr 12 hr Conversion",
      "Days Month Conversion",
    ],
  },
  {
    title: "➕ Time Calculations",
    desc: "Solve time calculation problems.",
    className: "word-card",
    btnClass: "word-btn",
    levels: [
      "Add Sub",
      "Time Word Problems",
    ],
  },
  {
    title: "📅 Calendar",
    desc: "Practice calendar concepts and problems.",
    className: "english-card",
    btnClass: "english-btn",
    levels: [
      "Calendar",
      "Calendar Word Problems",
    ],
  },
];

const multipleFactorsGroups = [
  {
    title: "🔢 Multiples",
    desc: "Practice multiples and common multiples.",
    className: "math-card",
    btnClass: "level-btn",
    levels: [
      "Multiples",
      "Common Multiples",
      "LCM",
       "LCM WORD PROBLEMS"
    ],
  },
  {
    title: "🧮 Factors",
    desc: "Learn factors and prime factorisation.",
    className: "science-card",
    btnClass: "science-btn",
    levels: [
      "Prime Factorisation",
      "HCF EASY",
      "HCF MEDIUM",
      "HCF LCM Relation",
      "COPRIMES",
      "HCF WORD PROBLEMS",
     
    ],
  },
  {
    title: "✅ Divisibility",
    desc: "Practice divisibility tests.",
    className: "english-card",
    btnClass: "english-btn",
    levels: [
      "Divisibles",
    ],
  },
];
const decimalLabels = {
  1: "🔢 Place Value",
  2: "⚖️ Compare Decimals",
  3: "🧩 Expanded Form",
  4: "✍️ Standard Form",
  5: "🔄 Decimal–Fraction Conversion",
  6: "🔟 Like Decimal Conversion",
  7: "➕➖✖️ Add, Subtract & Multiply",
  8: "➗ Decimal Division",
};

const mathLevelLabels = {
  1: "➕Column Addition",
  2: "➖Column Subtraction",
 3: "🔢Addition & Subtraction",
  4: "⚡Speed Math",
  5: "🎡Puzzle Wheel",
  6: "💎Addition Word Problem",
  7: "🚀Subtraction Word Problem",
};
const mathLevelLabelsPrim = {
  1: "➕ Column Addition",
  2: "➖ Column Subtraction",
  3: "🔢 Addition & Subtraction",
  4: "⚡ Speed Math Challenge",
  5: "🎡 Puzzle Wheel",
  6: "🍎 2-Digit Addition Stories",
  7: "🚀 3-Digit Addition Stories",
  8: "🏆 4-Digit Addition Stories",
  9: "🐻 2-Digit Subtraction Stories",
  10: "🎈 3-Digit Subtraction Stories",
  11: "💎 4-Digit Subtraction Stories",
};


const placeValueGroups = [
  {
    title: "🔢 Place Value",
    desc: "Build a strong foundation in place value.",
    className: "math-card",
    btnClass: "level-btn",
    levels: [
      "Place Value Easy",
      "Place Value Medium",
      "Place Value Hard",
      "Indian Place Value",
      "Number Formation",
    ],
  },
  {
    title: "📝 Expanded Form",
    desc: "Practice writing numbers in expanded form.",
    className: "word-card",
    btnClass: "word-btn",
    levels: [
      "Expanded Form Easy",
      "Expanded Form Medium",
      "Expanded Form Hard",
      "Expanded Form Master",
    ],
  },
  {
    title: "✍️ Standard Form",
    desc: "Convert numbers into standard form.",
    className: "science-card",
    btnClass: "science-btn",
    levels: [
      "Standard Form Easy",
      "Standard Form Medium",
      "Standard Form Hard",
      "Standard Form Master",
    ],
  },
  {
    title: "🌍 Advanced",
    desc: "Master advanced place value concepts.",
    className: "english-card",
    btnClass: "english-btn",
    levels: [
      "Rounding Off",
      "International Place Value",
      "Roman Numerals",
    ],
  },
];
const mathLevelLabelsPrim3 = {
  
  3: "🔢 Addition & Subtraction",
  4: "⚡ Speed Math Challenge",
  5: "🎡 Puzzle Wheel",
  6: "🍎 2-Digit Addition Stories",
  7: "🚀 3-Digit Addition Stories",

  9: "🐻 2-Digit Subtraction Stories",
  10: "🎈 3-Digit Subtraction Stories",

};
const mulLevelLabelsPrim = {
  1: "✖️ Multiplication Table 20",
  2: "🚀 Tables Challenge",
  3: "🎡 Puzzle Wheel",
  4: "🍎 Story Problems • Easy",
  5: "🚗 Story Problems • Medium",
  6: "🏆 Story Problems • Hard",
  7: "💎 Story Problems • Expert",
  8: "👑 Story Problems • Master",
};
const mulLevelLabelsPrim3 = {
  1: "✖️ Multiplication Table 20",
  2: "🚀 Tables Challenge",
  3: "🎡 Puzzle Wheel",
  4: "🍎 Story Problems • Easy",
  5: "🚗 Story Problems • Medium",
  6: "🏆 Story Problems • Hard",

};
const divLevelLabelsPrim = {
  1: "➗ Division Basics",
  2: "🚀 Division Challenge",
  3: "🎡 Division with Decimals",
  4: "🍎 Story Problems • Easy",
  5: "🚗 Story Problems • Medium",
  6: "🏆 Story Problems • Hard",
  7: "💎 Story Problems • Expert",
};


const shapeGroups = [
  {
    title: "📐 Basic Shapes",
    desc: "Learn and identify basic shapes.",
    className: "math-card",
    btnClass: "level-btn",
    levels: [1, 2, 3],
  },
  {
    title: "⭕ Circle",
    desc: "Practice circle concepts.",
    className: "science-card",
    btnClass: "science-btn",
    levels: ["Radius Diameter", "Perimeter"],
  },
];


  // if( level === "gradewise4")
  //    level="primary" 
 
  const levels =
  (category === "fraction" ||
  category === "money"  ) && level==="primary"
    ? [1, 2, 3, 4]
    :category === "measure"  && level==="primary"
    ? [1,2,3,4]
  :  (category === "fraction" ||
  category === "money" || category === "measure" ) && level==="gradewise3"
    ? [1, 2,3]
  :  (category === "fraction" ||
  category === "money" || category === "measure" ) && level==="gradewise2"
    ? [1, 2]
  :  (category === "fraction" ||
  category === "money" || category === "measure" ) && level==="gradewise1"
    ? [1]
  :  (category === "fraction" ||
  category === "money" || category === "measure" ) && level==="gradewise4"
    ? [1,2,3,4]
    : category === "division" && level==="primary"
    ? [1, 2, 3, 4,5,6,7]
    // : category === "time" && level==="primary"
    // ? [1, 2, 3,"Min Sec Conversion", "24hr 12 hr Conversion", "Add Sub", "Time Word Problems", "Calendar", 
    //   "Days Month Conversion",  "Calendar Word Problems"]
    : category === "time" && level==="gradewise4"
    ? [1, 2, 3,"Min Sec Conversion",  "Add Sub", "Time Word Problems", "Calendar", 
      "Days Month Conversion",  "Calendar Word Problems"]
    : category === "time" && level==="gradewise3"
    ? [1, 2, 3,"Min Sec Conversion",  "Add Sub", "Time Word Problems", "Calendar", 
      "Days Month Conversion",  "Calendar Word Problems"]
    : category === "time" && level==="gradewise2"
    ? [1, 2, 3,"Min Sec Conversion", "Calendar"]
    : category === "time" && level==="gradewise1"
    ? [1, 2, 3,"Min Sec Conversion", "Calendar"]
    : category === "shapes" && level==="gradewise4"
    ? [1, 2, 3,"Radius Diameter", "Perimeter"]
    : category === "shapes" && level==="gradewise3"
    ? [1, 2, 3,"Radius Diameter", "Perimeter"]
    : category === "shapes" && ( level==="gradewise2" || level==="gradewise1")
    ? [1, 2, 3]
//     : category === "multiplefactors" && level==="primary"
//     ? ["Multiples", "Common Multiples", "LCM", "Prime Factorisation",
// "HCF", "HCF LCM Relation", "Divisibles"]
    : category === "multiplefactors" && level==="gradewise5"
    ? ["Multiples", "Common Multiples", "LCM", "Prime Factorisation","COPRIMES","LCM WORD PROBLEMS","HCF WORD PROBLEMS",
"HCF MEDIUM","Divisibles"]
    : category === "multiplefactors" && level==="gradewise4"
    ? ["Multiples", "Common Multiples", "LCM", "Prime Factorisation",
"HCF EASY","Divisibles"]
    : category === "multiplefactors" && level==="gradewise3"
    ? ["Multiples", "Common Multiples", "LCM", "Prime Factorisation",
"HCF EASY"]
    : category === "multiplication" && level==="primary"
    ? [1, 2, 3, 4,5,6,7,8]
    : category === "math" && level==="kindergarten"
    ? [1, 2, 3, 4,5,6,7]
    : category === "math" && level==="primary"
    ? [1, 2, 3, 4,5,6,7,8,9,10,11]
    : category === "math" && level==="gradewise3"
    ? [3, 4,5,6,7,9,10]
    : category === "math" && level==="gradewise4"
    ? [3, 4,5,6,7,9,10]
    // :( category=== "placevalue" ) && level==="primary" 
    //  ? ["Place Value Easy", "Place Value Medium","Place Value Hard", "Indian Place Value", "Number Formation", 
    //   "Expanded Form Easy" , "Expanded Form Medium" , "Expanded Form Hard" , "Expanded Form Master" ,
    //    "Standard Form Easy" , "Standard Form Medium", "Standard Form Hard","Standard Form Master", 
    //   "Rounding Off", "International Place Value", "Roman Numerals"]
    :( category=== "placevalue" ) && level==="gradewise4" 
     ? ["Place Value Hard", "Number Formation", "Expanded Form Hard" , "Standard Form Hard" , 
      "Rounding Off", "Roman Numerals"]
    :( category=== "placevalue" ) && level==="gradewise3" 
     ? ["Place Value Hard", "Number Formation", "Expanded Form Hard" , "Standard Form Hard" , 
      "Rounding Off", "Roman Numerals"]
    :( category=== "placevalue" ) && level==="gradewise2" 
     ? ["Place Value Medium", "Number Formation", "Expanded Form Medium" , "Standard Form Medium"]
    :( category=== "placevalue" ) && level==="gradewise1" 
     ? ["Place Value Easy", "Expanded Form Easy"  ,"Standard Form Easy" ]
   :( level ==="olympiad") && category==="grade4"
   ? ["Large Numbers","Addition","Subtraction","Multiplication","Division","Factors",
    "Geometry","Measurement","Time","Money","Symmetry and Patterns"
   ]
   :( level ==="olympiad") && category==="grade3"
   ? ["Numbers","Addition","Subtraction","Multiplication","Division",
    "Geometry","Measurement","Time","Money","Symmetry and Patterns"
   ]
     : [1, 2, 3];

const normalLevels = levels.filter((lev) => lev !== 6);
const wordProblemLevel = levels.find((lev) => lev === 6);
const mulnormalLevels = levels.filter((lev) => lev !== 4);
const mulwordProblemLevel = levels.find((lev) => lev === 4);

  return (
    <div style={{
      margin: 0,
      
      display: "flex",
      flexDirection: "column",
           alignItems: "center",
       justifyContent: "center",
      minHeight: "100vh",
      // background: "linear-gradient(135deg, #ffd54f, #ff7043)",
         background: "linear-gradient(135deg, #821f82  0%,  #5b84de 60%,#315cb9 100%)",
  boxShadow:
    "0 10px 30px rgba(49, 92, 185, 0.35), 0 2px 8px rgba(255,255,255,0.15) inset",
  borderRadius: "0px",
      padding: "5px",
      position: "relative",
      boxSizing: "border-box",
    }}>
      <Confetti width={width} height={height} numberOfPieces={100} recycle={true} gravity={0.2} />
      
       <Card
        // title={
        //   <div
        //     style={{

        //       fontSize: windowWidth<420?"1.5rem":"2rem",
        //       fontWeight: "bold",
        //       color: "#ff6b00",
              
        //       textAlign: "center",
        //       padding: 10,
        //     }}
        //   >
        //     🧠 {level ? "Select Quiz Category" : "Choose Level"}
        //   </div>
        // }
        style={{
           fontSize: "clamp(1.5rem, 4vw, 2rem)",
          width: "100%",
          maxWidth: 1000, // responsive max width
          textAlign: "center",
          background:"transparent",
          borderRadius: 20,
          padding: 0,
        }}
      >
      <h1 style={{
        fontSize: "clamp(1.5rem, 4vw, 3rem)",
        fontWeight: "bold",
        color: "#fff",
        textAlign: "center",
        textShadow: "3px 3px 0px #ff6b00",
        marginBottom: "40px",
      }}>
        🏆 Select Level
      </h1>

      <div style={{
         
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        justifyContent: "center",
      }}>
{category === "placevalue" && level === "primary" ? (
  <div
    style={{
      display: "flex",
      gap: "30px",
      justifyContent: "center",
      flexWrap: "wrap",
      width: "100%",
    }}
  >
    {placeValueGroups.map((group) => (
      <div key={group.title} className={`level-card ${group.className}`}>
        <h2>{group.title}</h2>
        {/* <p>{group.desc}</p> */}

        <div className="level-list">
          {group.levels.map((lev) => (
            <Button
              key={lev}
              className={group.btnClass}
              onClick={() =>
                onSelectLevel(
                  lev,
                  motivationList[
                    Math.floor(Math.random() * motivationList.length)
                  ]
                )
              }
            >
              {lev}
            </Button>
          ))}
        </div>
      </div>
    ))}
  </div>
) 
:
category === "multiplefactors" && (level === "primary" )  ? (
  <div
    style={{
      display: "flex",
      gap: "30px",
      justifyContent: "center",
      flexWrap: "wrap",
      width: "100%",
    }}
  >
    {multipleFactorsGroups.map((group) => (
      <div key={group.title} className={`level-card ${group.className}`}>
        <h2>{group.title}</h2>
      

        <div className="level-list">
          {group.levels.map((lev) => (
            <Button
              key={lev}
              className={group.btnClass}
              onClick={() =>
                onSelectLevel(
                  lev,
                  motivationList[
                    Math.floor(Math.random() * motivationList.length)
                  ]
                )
              }
            >
              {lev}
            </Button>
          ))}
        </div>
      </div>
    ))}
  </div>
)
: category === "multiplefactors" &&
  (
    level === "gradewise3" ||
    level === "gradewise4" ||
    level === "gradewise5"
  ) ? (
  <div
    style={{
      display: "flex",
      flexDirection:"column",
      gap: "10px",
      justifyContent: "center",
      flexWrap: "wrap",
      width: "100%",
    }}
  >

    {/* Multiples & Factors Card */}
    <div >
     

      <div >
        {(
          level === "gradewise3"
            ? [
                "Multiples",
                "Common Multiples",
                "LCM",
                "Prime Factorisation",
                "HCF EASY",
              ]
            : level === "gradewise4"
            ? [
                "Multiples",
                "Common Multiples",
                "LCM",
                "Prime Factorisation",
                "HCF EASY",
                "Divisibles",
              ]
            : [
                "Multiples",
                "Common Multiples",
                "LCM",
                "Prime Factorisation",
                "COPRIMES",
                "LCM WORD PROBLEMS",
                "HCF WORD PROBLEMS",
                "HCF MEDIUM",
                "Divisibles",
              ]
        ).map((lev) => (
          <Button
            key={lev}
            className="level-btn"
            onClick={() =>
              onSelectLevel(
                lev,
                motivationList[
                  Math.floor(
                    Math.random() * motivationList.length
                  )
                ]
              )
            }
          >
            {lev}<br></br>
          </Button>
        ))}
      </div>
    </div>

  </div>
)
:category === "time" && level === "primary" ? (
  <div
    style={{
      display: "flex",
      gap: "30px",
      justifyContent: "center",
      flexWrap: "wrap",
      width: "100%",
    }}
  >
    {timeGroups.map((group) => (
      <div key={group.title} className={`level-card ${group.className}`}>
        <h4>{group.title}</h4>
        {/* <p>{group.desc}</p> */}

        <div className="level-list">
          {group.levels.map((lev) => (
            <Button
              key={lev}
              className={group.btnClass}
              onClick={() =>
                onSelectLevel(
                  lev,
                  motivationList[
                    Math.floor(Math.random() * motivationList.length)
                  ]
                )
              }
            >
              {lev}
            </Button>
          ))}
        </div>
      </div>
    ))}
  </div>
)
:category === "shapes" && level === "primary" ? (
  <div
    style={{
      display: "flex",
      gap: "30px",
      justifyContent: "center",
      flexWrap: "wrap",
      width: "100%",
    }}
  >
    {shapeGroups.map((group) => (
      <div key={group.title} className={`level-card ${group.className}`}>
        <h2>{group.title}</h2>
        {/* <p>{group.desc}</p> */}

        <div className="level-list">
          {group.levels.map((lev) => (
            <Button
              key={lev}
              className={group.btnClass}
              onClick={() =>
                onSelectLevel(
                  lev,
                  motivationList[
                    Math.floor(Math.random() * motivationList.length)
                  ]
                )
              }
            >
              {lev}
            </Button>
          ))}
        </div>
      </div>
    ))}
  </div>
)


:category === "decimal"  ? (
  <div
    style={{
      display: "flex",
      gap: "30px",
      justifyContent: "center",
      flexWrap: "wrap",
      width: "100%",
    }}
  >

    <div className="level-card word-card">
<p>Practice and master math skills!</p>
  

  <div className="level-list">
    {([1,2,3,4]).map((lev) => (
      <Button
        key={lev}
        className="word-btn"
        onClick={() =>
          onSelectLevel(
            lev,
            motivationList[
              Math.floor(Math.random() * motivationList.length)
            ]
          )
        }
      >
        {decimalLabels[lev]}
      </Button>
    ))}
  </div></div>
   <div className="level-card word-card">
    <p>Solve real-life stories and become a Math Hero!</p>
  <div className="level-list">
    {([5,6, 7, 8]).map((lev) => (
      <Button
        key={lev}
        className="word-btn"
        onClick={() =>
          onSelectLevel(
            lev,
            motivationList[
              Math.floor(Math.random() * motivationList.length)
            ]
          )
        }
      >
        {decimalLabels[lev]}
      </Button>
    ))}
  </div></div>

  </div>
) : 

category === "math" &&
(level === "primary" || level === "gradewise3" || level === "gradewise2" ||
   level === "gradewise1" || level === "gradewise4")  ? (
  <div
    style={{
      display: "flex",
      gap: "30px",
      justifyContent: "center",
      flexWrap: "wrap",
      width: "100%",
    }}
  >
    {/* Math Challenges Card */}
    <div className="level-card math-card">
      <h2>🧮 Math Challenges</h2>
      <p>Practice and master math skills!</p>

      <div className="level-list">
  {(
    level === "gradewise1"
      ? [1, 2, 3]
      : level === "gradewise2"
      ? [1, 2, 3]
      : level === "primary"
      ? [1, 2, 3, 4, 5]
      : [3, 4, 5]
  ).map((lev) => (
    <Button
      key={lev}
      className="level-btn"
      onClick={() =>
        onSelectLevel(
          lev,
          motivationList[
            Math.floor(Math.random() * motivationList.length)
          ]
        )
      }
    >
      {mathLevelLabelsPrim[lev]}
    </Button>
  ))}
</div>
    </div>

    {/* Word Problems Card */}
    <div className="level-card word-card">
  <h2>📖 Word Problems</h2>
  <p>Solve real-life stories and become a Math Hero!</p>

  <div className="level-list">
    {(
      level === "gradewise1"
        ? [6]
        : level === "gradewise2"
        ? [6, 7, 9]
        : level === "primary"
        ? [6, 7, 8, 9, 10, 11]
        : [6, 7, 9, 10]
    ).map((lev) => (
      <Button
        key={lev}
        className="word-btn"
        onClick={() =>
          onSelectLevel(
            lev,
            motivationList[
              Math.floor(Math.random() * motivationList.length)
            ]
          )
        }
      >
        {mathLevelLabelsPrim[lev]}
      </Button>
    ))}
  </div>
</div>
  </div>
) : 
category === "multiplication" && 
(level === "primary" || level === "gradewise3" || level === "gradewise2" ||
   level === "gradewise1" || level === "gradewise4")  ? (
 <div
  style={{
    display: "flex",
    gap: "30px",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
  }}
>
  {/* Math Challenges Card */}
  <div className="level-card math-card">
    <h2>🧮 Multiplication Challenges</h2>
    <p>Practice and master multiplicaton skills!</p>

    <div className="level-list">
      
      {[1, 2, 3].map((lev) => (
        <Button
          key={lev}
          className="level-btn"
          onClick={() =>
            onSelectLevel(
              lev,
              motivationList[
                Math.floor(Math.random() * motivationList.length)
              ]
            )
          }
        >
          {mulLevelLabelsPrim[lev]}
        </Button>
      ))}
    </div>
  </div>

  {/* Word Problems Card */}
  <div className="level-card word-card">
  <h2>📖 Word Problems</h2>
  <p>Solve real-life stories and become a Math Hero!</p>

  <div className="level-list">
    {(
      level === "gradewise1"
        ? [4]
        : level === "gradewise2"
        ? [4, 5]
        : level === "gradewise3"
        ? [4, 5, 6]
        : level === "gradewise4"
        ? [4, 5, 6,7,8]
        : [4, 5, 6,7,8]
    ).map((lev) => (
      <Button
        key={lev}
        className="word-btn"
        onClick={() =>
          onSelectLevel(
            lev,
            motivationList[
              Math.floor(Math.random() * motivationList.length)
            ]
          )
        }
      >
        {mulLevelLabelsPrim[lev]}
      </Button>
    ))}
  </div>
</div>
</div>
) : 
category === "division" &&
(level === "primary" || level === "gradewise3" || level === "gradewise2" || 
  level === "gradewise1" || level === "gradewise4")  ? (
 <div
  style={{
    display: "flex",
    gap: "30px",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
  }}
>
  {/* Math Challenges Card */}
  <div className="level-card math-card">
    <h2>🧮 Division Challenges</h2>
    <p>Practice and master division skills!</p>

    <div className="level-list">
      {[1, 2, 3].map((lev) => (
        <Button
          key={lev}
          className="level-btn"
          onClick={() =>
            onSelectLevel(
              lev,
              motivationList[
                Math.floor(Math.random() * motivationList.length)
              ]
            )
          }
        >
          {divLevelLabelsPrim[lev]}
        </Button>
      ))}
    </div>
  </div>

  {/* Word Problems Card */}
  <div className="level-card word-card">
    <h2>📖 Word Problems</h2>
    <p>Solve real-life stories and become a Math Hero!</p>

    <div className="level-list">
       {(level === "primary" ? [4, 5,6,7] : [4, 5,6]).map((lev) => (
     
        <Button
          key={lev}
          className="word-btn"
          onClick={() =>
            onSelectLevel(
              lev,
              motivationList[
                Math.floor(Math.random() * motivationList.length)
              ]
            )
          }
        >
          {divLevelLabelsPrim[lev]}
        </Button>
      ))}
    </div>
  </div>
</div>
) : (
  levels.map((lev) => (
    <Button
      key={lev}
      type="primary"
      size="large"
      style={{
        fontSize: "clamp(1rem, 2vw, 1.75rem)",
        padding: "15px 30px",
        borderRadius: "20px",
        fontWeight: "bold",
        background: "linear-gradient(135deg, #ff9d2f, #ff6126)",
        color: "#fff",
        boxShadow: "0 6px 15px rgba(0,0,0,0.2)",
        flex: "1 1 150px",
        minWidth: "170px",
        maxWidth: "290px",
        textAlign: "center",
        whiteSpace: "normal",
        height: "auto",
      }}
      onClick={() =>
        onSelectLevel(
          lev,
          motivationList[Math.floor(Math.random() * motivationList.length)]
        )
      }
    >
      {category === "math" && level === "kindergarten"
        ? mathLevelLabels[lev]
        : (category === "placevalue" || level === "olympiad" || category==="shapes" || category ==="time")
        ? lev
        : "Level " + lev}
    </Button>
  ))
)
}



      </div></Card>
    </div>

  );
};

export default LevelSelection;
